<template>
    <v-card dense style="border-radius:4px;">
        <v-toolbar flat height="45px">
            <span class="font-weight-bold ">Click {{ headerName }} to copy</span>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="closeDialog">
                <v-icon >close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-card-text>    
            <v-layout row wrap class="form-container">  
                <v-layout row wrap> 
                    <v-flex xs12 sm12>
                        <v-autocomplete
                            id="type_list"
                            v-model="selected_name"
                            :items="selected_names"
                            :loading="loading"
                            color="blue-grey lighten-2"
                            :label="typeName"
                            >
                        </v-autocomplete>
                    </v-flex>
                </v-layout>
            </v-layout> 
        </v-card-text>  
        <v-divider></v-divider>
        <v-card-actions style="margin:0px 20px 20px 0px;"> 
            <v-spacer></v-spacer>
            <v-btn @click="copy" title="Copy" class="primary">
                <v-icon>content_copy</v-icon>&nbsp;&nbsp;Copy
            </v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
import projectsApi from '@/api/projects'
export default {
    name: 'CopyName',
    data () {
        return {
            headers: [
                {text:'Name', align:'left', value:'name', width:'5%', sortable:true},
            ],
            type: '',
            loading: false,
            search: null,
            projects: null,
            selected_name: null,
            selected_names: []
        }
    },
    methods: {
        async setData(data) {
            this.search = null
            this.type = data.type
            if (!this.projects) {
                await this.getProjects()
            }
            this.setSelectedNames()
            this.headers[0].text = this.headerName
            document.getElementById("type_list").click();
        },
        copy() {
            this.closeDialog()
            const data = {
                type: this.type,
                name: this.selected_name
            }
            this.$emit('send', data)
        },
        closeDialog() {
            this.$emit('update:dialogCopy', false)
        },
        async getProjects() {
            try{
                this.loading = true
                const response = await projectsApi.get(true)
                if (response && response.status == 200) {                    
                    this.projects = response.data.items                    
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        setSelectedNames() {
            switch(this.type) {
                case 'project':
                    this.selected_names = [... new Set(this.projects.filter(x => x.projectName!='Admin').map(x => x.projectName))] 
                    break;
                case 'code':
                    this.selected_names = [... new Set(this.projects.filter(x => x.projectName!='Admin' && x.projectCode).map(x => x.projectCode))]
                    break;
                case 'client':
                    this.selected_names = [... new Set(this.projects.filter(x => x.projectName!='Admin' && x.client).map(x => x.client))]
                    break;
                case 'task_code':
                    this.selected_names = [...new Set(this.projects.filter(x => x.projectName!='Admin').flatMap(item => 
                                                item.projectTasks.filter(x => x.taskCode).map(task => task.taskCode)
                                            ))];
                    break;
                case 'task_name':
                    this.selected_names = [...new Set(this.projects.filter(x => x.projectName!='Admin').flatMap(item => 
                                                item.projectTasks.map(task => task.taskName)
                                            ))];
                    break;
                
            }
        }
    },
    computed: {
        headerName() {
            switch(this.type) {
                case 'project':
                    return 'Project Name'
                case 'code':
                    return 'Project Code'
                case 'client':
                    return 'Client'
                case 'task_code':
                    return 'Task Code'
                case 'task_name':
                    return 'Task Name'
            }
        },
        selected_names_filtered() {
            var temp = this.selected_names

            //search handler
            if (this.search) {
                temp = temp.filter(item => {
                    return ( item.toLowerCase().includes(this.search.toLowerCase()))
                })
            }
            return temp
        },
        typeName() {
            return this.type.replace('_',' ').toLocaleUpperCase()
        }
    },
    created() {}
}
</script>
<style scoped>
.form-container {
    padding:0px 20px 0px 20px;
}
</style>